if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    }; 
}


(function(){
	 addSpanButtons()
    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


	const prevArrowHTML =
	`<button aria-label="prev image" class="slick-arrow slick-next prevHiddenClick">
	</button>`;
	const nextArrowtHTML =
		`<button aria-label="next image" class="slick-arrow slick-next">
			<span class="nextArrow"></span>
			<span class="prevArrow"></span>
			<svg width="100" height="100" viewBox="0 0 72 72" preserveAspectRatio="none" fill="none" stroke="currentColor" stroke-width="1">
			<path fill="#231f20" stroke="#fff" stroke-width="0.5px" transform="translate(33 27)"
			d="M.642 17.323a.663.663 0 0 1-.467-1.132l7.424-7.417L.175 1.357A.664.664 0 0 1 .173.42.661.661 0 0 1 1.11.419l7.894 7.886a.664.664 0 0 1 0 .938L1.109 17.13a.659.659 0 0 1-.467.194z"/>
			<circle vector-effect="non-scaling-stroke" cx="36" cy="36" r="35" />
			<circle class="hover" vector-effect="non-scaling-stroke" cx="36" cy="36" r="34" stroke-width="2" />
			</svg>
		</button>`;



	const slickOptionsWhite = {
        accessibility: true,
        prevArrow: prevArrowHTML,
        nextArrow: nextArrowtHTML
    };


     $('.sym-slides').slick({
        accessibility: false,
        autoplay:true,
        autoplaySpeed:4000,
        speed:1000
    });

     $('.gallery-slider').slick({
        accessibility: false,
        autoplay:true,
        autoplaySpeed:4000,
        speed:1000
    });
	


	$("#gallery-block__arrows .slick-prev").click(function(){
        $(".gallery-slider").slick("slickPrev");
    });
    $("#gallery-block__arrows .slick-next").click(function(){
        $(".gallery-slider").slick("slickNext");
    });
	$('.sym-slider-block').slick({
        accessibility: true,
        autoplay:true,
		fade:true,
        autoplaySpeed:3000,
        speed:1000,
		arrows:false
    });
	$('.slick-prev').click(function() {
		 $('.sym-slider-block').slick('slickPrev');
	});
	$('.slick-next').click(function() {
		$('.sym-slider-block').slick('slickNext');
	});


	$('.sym-dining-overview').slick({
        accessibility: true,
		arrows:true,
        autoplay:true,
		fade:true,
        autoplaySpeed:4000,
        speed:1000,
    });


	$('.sym-slides-accommodations').slick({
        accessibility: true,
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 7000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'linear',
    });




	let BurgerMenu = document.getElementById('js_btn_menu');
	let NavigationBox = document.getElementById('navigationBox');
	let Body = document.body;
	let Header = document.getElementById('header');

	//Section Menu
	if(BurgerMenu){
		BurgerMenu.addEventListener('click', function(e){
			e.preventDefault();
			if(this.classList.contains("open")){
				this.classList.remove('open');
				NavigationBox.classList.remove('open');
				Body.classList.remove('scroll-no');
				Header.classList.remove('open');
				 // Header.classList.add('header-scroll');
				document.querySelectorAll('#logoHeader')[0].classList.remove('hidden');
				document.querySelectorAll('#headerRight')[0].classList.remove('hidden');

				if(document.querySelectorAll('#default')[0] != null){
					document.querySelectorAll('#default')[0].classList.remove('overflow-hidden');
				}
				if(document.querySelectorAll('#home')[0] != null){
					document.querySelectorAll('#home')[0].classList.remove('overflow-hidden');
				}
			} else {
				this.classList.add('open');
				NavigationBox.classList.add('open');
				Body.classList.add('scroll-no');
				Header.classList.add('open');
				// Header.classList.remove('header-scroll');
				document.querySelectorAll('#logoHeader')[0].classList.add('hidden');
				document.querySelectorAll('#headerRight')[0].classList.add('hidden');
				window.scrollTo(0, 0);
				
				if(document.querySelectorAll('#default')[0] != null){
					document.querySelectorAll('#default')[0].classList.add('overflow-hidden');
				}
				if(document.querySelectorAll('#home')[0] != null){
					document.querySelectorAll('#home')[0].classList.add('overflow-hidden');
				}

			}
		});
	}

	//SECTION ANIMATION FORM
	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		}) 
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
		this.parentElement.classList.add('moved');
		})

	}
	//CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
		for(let j = 0; j < allffields.length; j++){
			
			if(allffields[j].getElementsByTagName('input').length > 0){
				if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
					allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
						this.parentElement.classList.add('moved');
					})
				  }
			 }
			if(allffields[j].getElementsByTagName('select').length > 0){
				allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
					this.parentElement.classList.add('moved');
				})
			}
			if(allffields[j].getElementsByTagName('textarea').length > 0){
				allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
					this.parentElement.classList.add('moved');
				})
			}
		}
	}

	window.onload = function() {
		let bookingBWCTAFound = false;
		let findBWCta = setInterval(() => {
			if( document.querySelector(`.btn-booking-cms`) ){
				let spanBookNowOnBw = `<span class="btn-booking__horizontal"></span><span class="btn-booking__vertical"></span>`;
				document.querySelector(`.btn-booking-cms`).classList.add('btn-booking');
				document.querySelector(`.btn-booking-cms`).removeAttribute('style');
				document.querySelector(`.btn-booking-cms`).innerHTML += spanBookNowOnBw;
				document.querySelectorAll(`#booking_cms_select_rooms option`).forEach( (option, index) => {
					if( index > 0 )
						option.textContent += 's';
				} );
				document.querySelectorAll(`#booking_cms_select_adults option`).forEach( (option, index) => {
					if( index > 0 )
						option.textContent += 's';
				} );
				bookingBWCTAFound = true;
			}
			if( bookingBWCTAFound ){
				clearInterval(findBWCta);
			}
		}, 500);
	};

	//SECTION BUTTONS
	 /* Add span to all btns */
	function addSpanButtons() {
		document.querySelectorAll('.btn').forEach((ele) => {
				let actualtext = ele.textContent;
				ele.innerHTML = `${actualtext}
					<div class="btn__horizontal"></div>
					<div class="btn__vertical"></div>`;
		});

		document.querySelectorAll('.btn-blue').forEach((ele) => {
				let actualtext = ele.textContent;
				ele.innerHTML = `${actualtext}
				<div class="btn-blue__horizontal"></div>
				<div class="btn-blue__vertical"></div>`;
		});

		document.querySelectorAll('.signup-btn').forEach((ele) => {
				let actualtext = ele.textContent;
				ele.innerHTML = `${actualtext}
				<div class="btn-blue__horizontal"></div>
				<div class="btn-blue__vertical"></div>`;
		});
		
	}


	// ------ Script Quad Accordion --------
	var accordionItems = document.querySelectorAll('.accordion__item');
	var i;
	for (i = 0; i < accordionItems.length; i++) {
		let disItem = accordionItems[i];
		let disBtn = disItem.querySelector('.accordion__btn');
		disBtn.addEventListener('click', function () {
			disItem.classList.toggle('open');
		});
	}




	//Validation footer for padding top if it has slider quad
	let footer = document.querySelector('#footer_main');
	// find all section and verify if the last item has slider
	let main = document.querySelectorAll('#content section');
	let mainLenght = main.length-1;

	
	main.forEach((section,position) => {
		 //verify the last quad if it has slider
		 if(position == mainLenght){
			if (section.classList.contains('js-slider-inmersive')){
				footer.classList.add('js-footer-hight-slider');
				 section.classList.add('js-slider-inside-footer');

			}
		 }
	})



	//mobile burger menu
	document.getElementById('burgerMenu').addEventListener('click', function () {
		if (!this.classList.contains('open')) {
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.querySelector(".overlay").classList.add("open");
			document.getElementById("logo-sm").classList.remove("hidden");
			document.getElementById("social-mobile").classList.remove("hidden");
			let button = document.getElementById("Close").parentElement.parentElement;
			if (button.childNodes.length == 2) {
				let newText = document.createElement("div");
				newText.textContent = "CLOSE";
				newText.classList.add("jsCloseBtn")
				button.appendChild(newText);
			}
		}
		else {
			this.classList.remove('open');
			document.getElementById("logo-sm").classList.add("hidden");
			let button = document.getElementById("Close").parentElement.parentElement;
			button.removeChild();
			this.parentElement.classList.remove('open');
			document.querySelector(".overlay").classList.remove("open");
		}
	});

	//close btn mobile
	let closeBtn = document.querySelectorAll(".nav-container")[0];
	let newButton = closeBtn.childNodes[1];

	if (newButton != undefined) {

		if (closeBtn.childNodes[1].classList.contains("mobile")) {
			let generalbutton = closeBtn.childNodes[1].children[0].children[0];
			generalbutton.addEventListener('click', function () {
				document.getElementById("logo-sm").classList.add("hidden");
				document.getElementById("social-mobile").classList.add("hidden");
				document.querySelectorAll('.overlay')[0].classList.remove('open');
				document.getElementById('burgerMenu').classList.remove('open');

			})
		}
	}


	//ATTRACTIONS CHANGE TEXT
	let attractionLB = document.querySelector('#attraction-lightbox .additional-info');


	//dropdown for mobile
    document.querySelectorAll('.inner > ul > li').forEach(li => {
        let link = li.querySelector('a');
        console.log("🚀 ~ document.querySelectorAll ~ link:", link)
        let sublinks = li.querySelectorAll('div ul li');
        console.log("🚀 ~ document.querySelectorAll ~ sublinks:", sublinks)
        let submenu = li.querySelector('.sub-sub-menu');
        console.log("🚀 ~ document.querySelectorAll ~ submenu:", submenu)
    
        sublinks.forEach( sublink => {
            sublink.addEventListener('click', e => {
                e.stopPropagation();
            });
        })

        li.addEventListener('click', e => {
            if (submenu) {
                e.preventDefault(); 
                li.classList.toggle('js-submenu-show');
            }
        });
    
        
        link.addEventListener('click', e => {
            if (submenu) {
                e.stopPropagation();
            }
        });
    });
	//add class for icon dropdown 
	document.querySelectorAll('.inner > ul > li > .sub-sub-menu').forEach(link => {
		let menu = link.parentNode;
		menu.classList.add('ico-dropdown');
	})
	//--------------------


   // table section
   const tablesResp = document.querySelectorAll('.capacity__content table');
   if (tablesResp.length) {
	   tablesResp.forEach((tablei) => {
		   let tableresponsive = document.createElement('div');
		   tableresponsive.classList.add('tableHold');
		   tablei.parentNode.insertBefore(tableresponsive, tablei);
		   tableresponsive.append(tablei);
		   const ths = tablei.querySelectorAll('tr:first-child > *');
		   tablei.querySelectorAll('tr + tr').forEach((row) => {
			   const tds = row.querySelectorAll('td');
			   let i = 0;
			   for (i; i < tds.length; i++) {
				   tds[i].setAttribute('data-label', ths[i].textContent)
			   }
		   })
		   const rowHeads = tablei.querySelectorAll('tr');
		   rowHeads.forEach((ele) => {
			   let rowFullheight = ele.offsetHeight;
			   ele.addEventListener('click', () => {
				   ele.classList.toggle('active');
				if(ele.classList.contains('active')){
					ele.setAttribute('height', rowFullheight);
				}else{
					ele.setAttribute('height', 70+'px');
				}
			})	
		   })
	   })
   }
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
//ScrollW
function scrollW(){
    //check scroll down or up for header styles
    let st = window.pageYOffset || document.documentElement.scrollTop;
    let header = document.getElementById('header');
    if(st > 80){
        if (st > lastScrollTop){
            // downscroll code
            if(!header.classList.contains('down')){
                header.classList.add('down');
                header.classList.remove('up');
            }
        } else {
            // upscroll code
            if(!header.classList.contains('up')){
                header.classList.add('up');
                header.classList.remove('down');
            }
        }
    } else {
        if(header.classList.contains('up') || header.classList.contains('down')){
            header.classList.remove('up');
            header.classList.remove('down');
        }
    }

    let SubMenu = document.getElementById('subMenuAnchor');
    if(SubMenu){
        let subPost = document.getElementById('subMenu');
        let subPosition = '';
        if(document.body.classList.contains('alert_open')){
            subPosition = offset(SubMenu).top - 180;
        } else {
            subPosition = offset(SubMenu).top - 140;
        }
        if(st > subPosition){
            if(!subPost.classList.contains('floating-up')){
                subPost.classList.add('floating-up');
            }
        } else {
            if(subPost.classList.contains('floating-up')) {
                subPost.classList.remove('floating-up');
            }
        }
    }

    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

	
})();

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('#header');
    const isMenuVisible = menu && menu.classList.contains('open');
    const elements = document.querySelectorAll('#primary-nav a, #navigationMenu a, .navigation-info__down .social-media a');
    
    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('#header');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});
